import React from "react";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import { dishes } from "../data/dishes";
import { business } from "../data/business";
import { photos } from "../data/photos";
import { useTheme, useDocumentTitle, useSite } from "../hooks/useSite";
import waAvatar from "../../components/Socialmedia/wtsaplogo2.jpeg";

export default function FindUsPage() {
  useTheme(dishes[0]);
  useDocumentTitle("Find Us");
  const { openModal } = useSite();
  return (
    <section className="ro-locator">
      <div className="ro-container">
        <h1>
          Café <span className="ro-outline">Locator</span>
        </h1>
        <div className="ro-split ro-locator__split">
          <img className="ro-locator__photo" src={photos.store1} alt="Guests at the RollOver counter" />
          <div>
            <h2>
              <strong className="ro-italic">RollOver</strong>
              <br />
              Warangal
            </h2>
            <address>
              {business.address.lines.map((l) => (
                <span key={l}>
                  {l}
                  <br />
                </span>
              ))}
              <span className="ro-small">{business.address.landmark}</span>
            </address>
            <dl className="ro-locator__facts">
              <dt>Hours</dt>
              <dd>
                {business.hours.map((h) => (
                  <span key={h.days}>
                    {h.days}: {h.time}
                    <br />
                  </span>
                ))}
              </dd>
              <dt>Phone</dt>
              <dd>
                <a href={`tel:${business.phone.display.replace(/\s/g, "")}`}>{business.phone.display}</a>
              </dd>
            </dl>
            <div className="ro-locator__actions">
              <a className="ro-pill" href={business.directionsUrl} target="_blank" rel="noopener noreferrer">
                Get directions ↗
              </a>
              <button type="button" className="ro-pill" onClick={() => openModal("order")}>
                Order online ↗
              </button>
            </div>
          </div>
        </div>
        <div className="ro-map">
          <iframe
            title="RollOver Warangal on Google Maps"
            src={business.mapEmbed}
            width="100%"
            height="420"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
      <FloatingWhatsApp
        phoneNumber={business.phone.whatsapp}
        statusMessage="Typically replies within 1 hour"
        accountName="Rollover Warangal"
        avatar={waAvatar}
        allowClickAway
        styles={{ zIndex: 60 }}
      />
    </section>
  );
}
